import ButtonCommon from 'components/common/ButtonCommon';
import { checkFormInputValidation } from 'components/common/func';
import FormInputGenderRadio from 'components/FormEditReceiver/components/FormInputGenderRadio';
import FormInputValidation from 'components/FormEditReceiver/components/FormInputValidation';
import {
  EDIT_RECEIVER_COUNTRY_FIELD,
  EDIT_RECEIVER_COUNTRY_NAME,
  EDIT_RECEIVER_GENDER_NAME,
  EDIT_RECEIVER_GENERAL_DETAILS_NAME_FIELDS,
  EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS,
  EDIT_RECEIVER_MOBILE_NAME,
  EDIT_RECEIVER_PERSONAL_DETAILS_GENDER_FIELD,
  EDIT_RECEIVER_PHONE_NAME,
  EDIT_RECEIVER_RELATIONSHIP_FIELD,
  EDIT_RECEIVER_RELATIONSHIP_NAME,
} from 'constants';
import useLang from 'hooks/useLang';
import styled from 'styled-components';

import CustomSearchDropdown from 'components/common/CustomSearchDropdown/ver2';
import FormInputDisplayOnly from 'components/common/FormInputDisplayOnly';
import BodySectionHeader from 'components/FormAddReceiver/components/BodySectionHeader';
import FormInputMobileOrPhoneNumberValidation from 'components/FormEditReceiver/components/FormInputMobileOrPhoneNumberValidation';
import FormInputNameValidation from 'components/FormEditReceiver/components/FormInputNameValidation';
import {
  COUNTRIES,
  DESKTOP_MIN_WIDTH,
  EDIT_RECEIVER_BUSINESS_MOBILE_FIELD,
  EDIT_RECEIVER_BUSINESS_NAME_FIELD,
  EDIT_RECEIVER_BUSINESS_PHONE_FIELD,
  EDIT_RECEIVER_FISTNAME_NAME,
  EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD,
  EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME,
  PROPERTIES_NOT_IN_BUSINESS_RECEIVER_TYPE,
} from 'constants';
import withUpdateReceiverPersonalDetailsInitial from 'features/receiver/HOCs/withUpdateReceiverPersonalDetailsInitial';
import withUpdateReceiverPersonalDetailsValidationInitial from 'features/receiver/HOCs/withUpdateReceiverPersonalDetailsValidationInitial';
import useUpdateReceiver from 'features/receiver/hooks/useUpdateReceiver';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useVirtualKeyboard from 'hooks/useVirtualKeyboard';
import { isEmpty } from 'lodash';
import { Fade } from 'react-bootstrap';
import { fontSize12Mixin, fontSize14Mixin, paragraph500Mixin } from 'styles';
import FormInputSelectTypeOfReceiverRadio from './components/FormInputSelectTypeOfReceiverRadio';

const FULL_WIDTH_FIELD_STYLES = {
  float: 'unset',
  width: '100%',
};

const NEXT_BUTTON_FULL_WIDTH_STYLES = {
  margin: '0px',
  width: '100%',
};

const ACTION_BUTTON_HALF_WIDTH_STYLES = {
  margin: '0px',
  width: '50%',
};

const PersonalDetails = withUpdateReceiverPersonalDetailsInitial(
  withUpdateReceiverPersonalDetailsValidationInitial((props) => {
    const {
      countryConfig,
      currentStep,
      setCurrentStep,
      handleOnToggleCancelPopup,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
      mobileMaskStr,
      setMobileMaskStr,
      phoneMaskStr,
      setPhoneMaskStr,
      eitherRequiredMsg,
      setEitherRequiredMsg,
      mobileConfig,
      phoneConfig,
      relationshipConfig,
    } = props || {};

    const { t } = useLang();
    const { isDesktop } = useDetectDevice();
    const {
      configRelationship,
      configRelationshipOfBusiness,
      setAddReceiverPersonalDetails,
    } = useFormAddReceiverStore();

    const isShowEitherRequiredMsg =
      eitherRequiredMsg &&
      !validation[EDIT_RECEIVER_MOBILE_NAME] &&
      !validation[EDIT_RECEIVER_PHONE_NAME];

    const currentCountry = information[EDIT_RECEIVER_COUNTRY_NAME];
    const { code: countryCode, name: countryName } = currentCountry || {};
    const countryCodeShort =
      COUNTRIES.find((c) => c.value === countryCode)?.code || '';
    const isVietNamCountry = countryName === 'VIETNAM';

    const currentReceiverType =
      information[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME];
    const isReceiverOfIndividualType = currentReceiverType === 1;
    const isReceiverOfBusinessType = currentReceiverType === 2;

    const currentMobileNumber = information[EDIT_RECEIVER_MOBILE_NAME];
    const currentPhoneNumber = information[EDIT_RECEIVER_PHONE_NAME];

    const { ref: inputRef, KeyboardFittingElement } = useVirtualKeyboard();

    const { reCheckMobilePhoneNumberFn } = useUpdateReceiver();

    const isAllowRenderSelectTypeOfReceiverFormSection =
      !isEmpty(currentCountry);
    const renderSelectTypeOfReceiverForm = () => {
      if (!isAllowRenderSelectTypeOfReceiverFormSection) return null;
      return (
        <FormInputSelectTypeOfReceiverRadio
          countryConfig={countryConfig}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
      );
    };

    const renderNameForm = () => {
      if (isReceiverOfIndividualType) {
        if (isVietNamCountry)
          return (
            <>
              {EDIT_RECEIVER_GENERAL_DETAILS_NAME_FIELDS.slice(0, 2).map(
                (field) => (
                  <FormInputValidation
                    key={field.name}
                    ref={inputRef}
                    field={field}
                    information={information}
                    setInformation={setInformation}
                    validation={validation}
                    setValidation={setValidation}
                    isEdit={true}
                  />
                ),
              )}
            </>
          );

        if (!isVietNamCountry)
          return (
            <>
              {EDIT_RECEIVER_GENERAL_DETAILS_NAME_FIELDS.slice(0, 2)
                .reverse()
                .map((field) => (
                  <FormInputValidation
                    key={field.name}
                    ref={inputRef}
                    field={field}
                    information={information}
                    setInformation={setInformation}
                    validation={validation}
                    setValidation={setValidation}
                    isEdit={true}
                  />
                ))}
            </>
          );
      }

      if (isReceiverOfBusinessType) {
        return (
          <FormInputValidation
            ref={inputRef}
            key={EDIT_RECEIVER_BUSINESS_NAME_FIELD.name}
            field={EDIT_RECEIVER_BUSINESS_NAME_FIELD}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            styles={{
              width: '100%',
              float: 'unset',
              marginLeft: '0px',
              marginRight: '0px',
            }}
            isEdit={true}
          />
        );
      }

      return null;
    };

    const renderFullNameForm = () => {
      if (isVietNamCountry || !isAllowRenderNextSection) {
        return (
          <FormInputNameValidation
            ref={inputRef}
            field={EDIT_RECEIVER_GENERAL_DETAILS_NAME_FIELDS[2]}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            isEdit={true}
          />
        );
      }

      return null;
    };

    const renderGenderForm = () => {
      return (
        <FormInputGenderRadio
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
      );
    };

    const renderMobileForm = () => {
      if (mobileConfig?.visible && isReceiverOfIndividualType)
        return (
          <FormInputMobileOrPhoneNumberValidation
            ref={inputRef}
            field={EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[0]}
            config={mobileConfig}
            numberMaskStr={mobileMaskStr}
            setNumberMaskStr={setMobileMaskStr}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            setEitherRequiredMsg={setEitherRequiredMsg}
            styles={!phoneConfig.visible ? FULL_WIDTH_FIELD_STYLES : {}}
          />
        );

      if (mobileConfig?.visible && isReceiverOfBusinessType)
        return (
          <FormInputMobileOrPhoneNumberValidation
            ref={inputRef}
            field={EDIT_RECEIVER_BUSINESS_MOBILE_FIELD}
            config={mobileConfig}
            numberMaskStr={mobileMaskStr}
            setNumberMaskStr={setMobileMaskStr}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            setEitherRequiredMsg={setEitherRequiredMsg}
            styles={!phoneConfig.visible ? FULL_WIDTH_FIELD_STYLES : {}}
          />
        );

      return null;
    };

    const renderPhoneForm = () => {
      if (phoneConfig?.visible && isReceiverOfIndividualType)
        return (
          <FormInputMobileOrPhoneNumberValidation
            ref={inputRef}
            field={EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[1]}
            config={phoneConfig}
            numberMaskStr={phoneMaskStr}
            setNumberMaskStr={setPhoneMaskStr}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            setEitherRequiredMsg={setEitherRequiredMsg}
            styles={!mobileConfig.visible ? FULL_WIDTH_FIELD_STYLES : {}}
          />
        );

      if (phoneConfig?.visible && isReceiverOfBusinessType)
        return (
          <FormInputMobileOrPhoneNumberValidation
            ref={inputRef}
            field={EDIT_RECEIVER_BUSINESS_PHONE_FIELD}
            config={phoneConfig}
            numberMaskStr={phoneMaskStr}
            setNumberMaskStr={setPhoneMaskStr}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            setEitherRequiredMsg={setEitherRequiredMsg}
            styles={!mobileConfig.visible ? FULL_WIDTH_FIELD_STYLES : {}}
          />
        );

      return null;
    };

    const renderRelationshipForm = () => {
      if (relationshipConfig?.visible && isReceiverOfIndividualType)
        return (
          <CustomSearchDropdown
            ref={inputRef}
            field={EDIT_RECEIVER_RELATIONSHIP_FIELD}
            isConfigRequired={relationshipConfig?.required}
            data={configRelationship}
            keyFind="key"
            keyTranslate="value"
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            isClearBoth
            scrollUp={true}
          />
        );

      if (isReceiverOfBusinessType)
        return (
          <CustomSearchDropdown
            ref={inputRef}
            field={EDIT_RECEIVER_RELATIONSHIP_FIELD}
            isConfigRequired={true}
            data={configRelationshipOfBusiness}
            keyFind="key"
            keyTranslate="value"
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            isClearBoth
            scrollUp={true}
          />
        );

      return null;
    };

    const isAllowRenderNextSection =
      !isEmpty(currentCountry) && currentReceiverType;
    const renderEitherRequiredMsg = () => {
      if (!isShowEitherRequiredMsg) return null;
      return <ControlFeedback>{t(eitherRequiredMsg)}</ControlFeedback>;
    };
    const renderNextSection = () => {
      if (!isAllowRenderNextSection) return <>{renderFullNameForm()}</>;
      if (isReceiverOfIndividualType)
        return (
          <>
            {renderNameForm()}
            {renderFullNameForm()}
            {renderGenderForm()}
            {renderMobileForm()}
            {renderPhoneForm()}
            {renderEitherRequiredMsg()}
            {renderRelationshipForm()}
          </>
        );
      if (isReceiverOfBusinessType)
        return (
          <>
            {renderNameForm()}
            {renderMobileForm()}
            {renderPhoneForm()}
            {renderRelationshipForm()}
          </>
        );
      return null;
    };

    const handleNextStep = async () => {
      let newInformation = { ...information };
      let newValidation = { ...validation };

      if (isReceiverOfBusinessType) {
        PROPERTIES_NOT_IN_BUSINESS_RECEIVER_TYPE.forEach((prop) => {
          delete newInformation[prop];
          delete newValidation[prop];
        });
      }

      if (mobileConfig?.eitherRequired) {
        if (currentPhoneNumber && !validation[EDIT_RECEIVER_MOBILE_NAME]) {
          delete newInformation[EDIT_RECEIVER_MOBILE_NAME];
          delete newValidation[EDIT_RECEIVER_MOBILE_NAME];

          setEitherRequiredMsg('');
        }

        if (currentMobileNumber && !validation[EDIT_RECEIVER_PHONE_NAME]) {
          delete newInformation[EDIT_RECEIVER_PHONE_NAME];
          delete newValidation[EDIT_RECEIVER_PHONE_NAME];

          setEitherRequiredMsg('');
        }
      } else {
        if (!mobileConfig?.visible) {
          delete newInformation[EDIT_RECEIVER_MOBILE_NAME];
          delete newValidation[EDIT_RECEIVER_MOBILE_NAME];
        }

        if (!phoneConfig?.visible) {
          delete newInformation[EDIT_RECEIVER_PHONE_NAME];
          delete newValidation[EDIT_RECEIVER_PHONE_NAME];
        }

        if (
          !phoneConfig?.required &&
          phoneConfig?.visible &&
          !validation[EDIT_RECEIVER_PHONE_NAME]
        ) {
          delete newInformation[EDIT_RECEIVER_PHONE_NAME];
          delete newValidation[EDIT_RECEIVER_PHONE_NAME];
        }

        if (
          !mobileConfig?.required &&
          mobileConfig?.visible &&
          !validation[EDIT_RECEIVER_MOBILE_NAME]
        ) {
          delete newInformation[EDIT_RECEIVER_MOBILE_NAME];
          delete newValidation[EDIT_RECEIVER_MOBILE_NAME];
        }
      }

      if (!relationshipConfig?.required) {
        delete newInformation[EDIT_RECEIVER_RELATIONSHIP_NAME];
        delete newValidation[EDIT_RECEIVER_RELATIONSHIP_NAME];
      }

      delete newInformation?.relationshipIndividualInformationCache;
      delete newValidation?.relationshipIndividualInformationCache;

      console.log(
        `⭐ PersonalDetails 👉 handleNextStep ➡️ newInformation ↩`,
        newInformation,
      );
      console.log(
        `⭐ PersonalDetails 👉 handleNextStep ➡️ newValidation ↩`,
        newValidation,
      );
      const isAllowNext =
        Object.values(newInformation).every((value) => value) &&
        Object.values(newValidation).every((value) => !value) &&
        !eitherRequiredMsg;
      if (isAllowNext) {
        console.log(
          `⭐ PersonalDetails 👉 handleNextStep ➡️ isAllowNext ➡️ information ↩`,
          information,
        );
        const shouldCheckMobile = Boolean(
          currentMobileNumber && mobileConfig?.apiEnabled,
        );
        const shouldCheckPhone = Boolean(
          currentPhoneNumber && phoneConfig?.apiEnabled,
        );

        const payload = {
          countryCode: countryCodeShort,
          mobileConfig,
          mobileNumber: currentMobileNumber,
          phoneConfig,
          phoneNumber: currentPhoneNumber,
        };
        console.log(
          `⭐ PersonalDetails 👉 handleNextStep ➡️ isAllowNext ➡️ reCheckMobilePhoneNumberFn ➡️ payload ↩`,
          payload,
        );
        const responses = await reCheckMobilePhoneNumberFn(payload);

        console.log(
          `⭐ PersonalDetails 👉 handleNextStep ➡️ isAllowNext ➡️ reCheckMobilePhoneNumberFn ➡️ responses ↩`,
          responses,
        );

        if (!responses?.length) {
          setAddReceiverPersonalDetails(information);
          setCurrentStep(currentStep + 1);
          return;
        }

        let responseIndex = 0;
        const mobileRes = shouldCheckMobile ? responses[responseIndex] : null;
        const phoneRes = shouldCheckPhone ? responses[responseIndex++] : null;

        const isMobileNumberValid =
          !shouldCheckMobile || mobileRes?.data?.status === 'valid';
        const isPhoneNumberValid =
          !shouldCheckPhone || phoneRes?.data?.status === 'valid';

        if (isMobileNumberValid && isPhoneNumberValid) {
          setAddReceiverPersonalDetails(information);
          setCurrentStep(currentStep + 1);
          return;
        }

        const mobileField = isReceiverOfIndividualType
          ? EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[0]
          : EDIT_RECEIVER_BUSINESS_MOBILE_FIELD;
        const phoneField = isReceiverOfIndividualType
          ? EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[1]
          : EDIT_RECEIVER_BUSINESS_PHONE_FIELD;

        setValidation({
          ...validation,
          [EDIT_RECEIVER_MOBILE_NAME]: isMobileNumberValid
            ? ''
            : mobileField.msgNumberInvalid,
          [EDIT_RECEIVER_PHONE_NAME]: isPhoneNumberValid
            ? ''
            : phoneField.msgNumberInvalid,
        });
      } else {
        newValidation = checkFormInputValidation(
          countryName,
          EDIT_RECEIVER_COUNTRY_FIELD,
          newValidation,
        );

        newValidation = checkFormInputValidation(
          currentReceiverType?.toString(),
          EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD,
          newValidation,
        );

        if (isReceiverOfIndividualType) {
          EDIT_RECEIVER_GENERAL_DETAILS_NAME_FIELDS.forEach((field) => {
            newValidation = checkFormInputValidation(
              information[field.name],
              field,
              newValidation,
            );
          });
        } else if (isReceiverOfBusinessType) {
          newValidation = checkFormInputValidation(
            information[EDIT_RECEIVER_FISTNAME_NAME],
            EDIT_RECEIVER_BUSINESS_NAME_FIELD,
            newValidation,
          );
        }

        newValidation = checkFormInputValidation(
          information[EDIT_RECEIVER_GENDER_NAME],
          EDIT_RECEIVER_PERSONAL_DETAILS_GENDER_FIELD,
          newValidation,
        );

        if (isReceiverOfIndividualType) {
          if (mobileConfig?.eitherRequired) {
            if (!currentMobileNumber && !currentPhoneNumber) {
              setEitherRequiredMsg('form_mobile_phone_invalid_1');
            } else {
              setEitherRequiredMsg('');
            }
          } else {
            if (
              mobileConfig?.required &&
              !newValidation[EDIT_RECEIVER_MOBILE_NAME]
            ) {
              newValidation = checkFormInputValidation(
                currentMobileNumber,
                EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[0],
                newValidation,
              );
            }

            if (
              phoneConfig?.required &&
              !newValidation[EDIT_RECEIVER_PHONE_NAME]
            ) {
              newValidation = checkFormInputValidation(
                currentPhoneNumber,
                EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[1],
                newValidation,
              );
            }
          }
        } else if (isReceiverOfBusinessType) {
          if (mobileConfig?.eitherRequired) {
            if (!currentMobileNumber && !currentPhoneNumber) {
              setEitherRequiredMsg('form_mobile_phone_invalid_1');
            } else {
              setEitherRequiredMsg('');
            }
          } else {
            if (
              mobileConfig?.required &&
              !newValidation[EDIT_RECEIVER_MOBILE_NAME]
            ) {
              newValidation = checkFormInputValidation(
                currentMobileNumber,
                EDIT_RECEIVER_BUSINESS_MOBILE_FIELD,
                newValidation,
              );
            }

            if (
              phoneConfig?.required &&
              !newValidation[EDIT_RECEIVER_PHONE_NAME]
            ) {
              newValidation = checkFormInputValidation(
                currentPhoneNumber,
                EDIT_RECEIVER_BUSINESS_PHONE_FIELD,
                newValidation,
              );
            }
          }
        }

        if (relationshipConfig?.required) {
          newValidation = checkFormInputValidation(
            information[EDIT_RECEIVER_RELATIONSHIP_NAME]?.key,
            EDIT_RECEIVER_RELATIONSHIP_FIELD,
            newValidation,
          );
        }

        setValidation(newValidation);
      }
    };
    const renderActionsButton = () => {
      if (!isDesktop)
        return (
          <Fade in appear>
            <NextWrap>
              <ButtonCommon
                value={t('button_next')}
                color="var(--c-primary)"
                background="var(--bg-primary)"
                isFill={true}
                styles={NEXT_BUTTON_FULL_WIDTH_STYLES}
                onClick={handleNextStep}
                isUseKeyDown
              />
            </NextWrap>
          </Fade>
        );

      return (
        <Fade in appear>
          <NextWrap>
            <ButtonCommon
              value={t('button_cancel')}
              onClick={handleOnToggleCancelPopup}
              styles={ACTION_BUTTON_HALF_WIDTH_STYLES}
              color="var(--ds-c-blue)"
              background="var(--ds-c-white)"
            />
            <ButtonCommon
              value={t('button_next')}
              color="var(--c-primary)"
              background="var(--bg-primary)"
              isFill={true}
              styles={ACTION_BUTTON_HALF_WIDTH_STYLES}
              onClick={handleNextStep}
              isUseKeyDown
            />
          </NextWrap>
        </Fade>
      );
    };

    return (
      <>
        <BodySectionHeader
          titleBodySection={!isDesktop && t('edit_receiver_title')}
          titleSection={t('label_general_details')}
          onToggleCancelPopup={handleOnToggleCancelPopup}
          isDisabled={false}
        />
        <PersonalDetailsStyled>
          <FormInputDisplayOnly
            name={EDIT_RECEIVER_COUNTRY_FIELD.name}
            label={EDIT_RECEIVER_COUNTRY_FIELD.label}
            value={countryName}
            inputStyles={{
              background: 'var(--ds-c-grey-disabled)',
              color: 'var(--ds-c-grey-neutral)',
            }}
            isRequired
          />
          {renderSelectTypeOfReceiverForm()}
          {renderNextSection()}
          {renderActionsButton()}
        </PersonalDetailsStyled>
        <KeyboardFittingElement />
      </>
    );
  }),
);

const PersonalDetailsStyled = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: -8px;
  padding-inline: 0px;
  padding-bottom: 240px;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 437px;
    margin-top: 0px;
    padding-inline: 0px;
  }
`;

const NextWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 77px;
  width: 100%;
  margin-inline: -16px;
  padding-inline: 16px;
  background: var(--ds-c-white);
  z-index: 1;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #eef2f5;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;

    position: unset;
    margin-top: 40px;
    margin-bottom: 24px;
    margin-inline: unset;
    padding-inline: unset;
    width: 437px;
    height: 44px;
    border-top: unset;
  }
`;

const ControlFeedback = styled.p`
  ${paragraph500Mixin};
  ${fontSize12Mixin};
  color: var(--ds-c-red);
  position: relative;
  top: -30px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    ${fontSize14Mixin};
    display: table;
  }
`;

export default PersonalDetails;
